import { User } from '../models/user';

export class UpdateUserSuccess {
    static readonly type = '[User] UpdateUserSuccess';

    constructor(public payload: User) {}
}
